<template>
  <div>
    <a-button
      type="dashed"
      icon="plus"
      class="add-new"
      v-if="houseInfo.rentType == 32"
      @click="addNew"
      >新增房间</a-button
    >
    <room-item
      v-for="item in roomListItem"
      :baseInfo="baseInfo"
      :oss="oss"
      :ref="item.key"
      :key="item.key"
      @deleteItem="deleteItem"
      :refKey="item.key"
      :isDelete="item.isDelete"
    ></room-item>
    <div class="operation">
      <a-button :loading="loading" type="primary" @click="nextStep('default')"
        >保存</a-button
      >
      <a-button
        style="margin-left: 8px"
        :loading="loading"
        type="primary"
        @click="nextStep('up')"
        >保存并上架</a-button
      >
      <a-button style="margin-left: 8px" @click="prevStep">上一步</a-button>
    </div>
    <a-divider />
    <div class="step-form-style-desc">
      <h3>说明</h3>
      <h4>合租</h4>
      <p>这里填写每个房间的特有信息</p>
    </div>
  </div>
</template>

<script>
import RoomItem from "./RoomItem";
export default {
  name: "Step2",
  props: {
    oss: {
      type: Object,
      default: function() {
        return {};
      }
    },
    baseInfo: {
      type: Object,
      default: function() {
        return {};
      }
    },
    hinfo: {
      type: Object,
      default: function() {
        return {
          houseList: []
        };
      }
    }
  },
  components: {
    RoomItem
  },
  data() {
    return {
      loading: false,
      roomListItem: [{ key: "form-default", isDelete: false }],
      houseInfo: this.hinfo
    };
  },
  methods: {
    setHouseInfo(obj) {
      this.houseInfo = Object.assign({}, obj);
    },
    addNew() {
      let obj = {};
      obj.isDelete = true;
      obj.key = "form-" + new Date().getTime();
      this.roomListItem.push(obj);
    },
    deleteItem(key) {
      const newData = this.roomListItem.filter(item => item.key !== key);
      this.roomListItem = newData;
    },
    nextStep(type) {
      this.loading = true;
      let isCheckPass = true; //校验通过
      let arr = [];
      for (let obj of this.roomListItem) {
        let flag = this.$refs[obj.key][0].submit();
        let data = this.$refs[obj.key][0].formData;
        data.upDownType = type;
        data.houseName =
          this.houseInfo.communityName +
          this.houseInfo.buildingNo +
          "-" +
          this.houseInfo.unitNo +
          "-" +
          this.houseInfo.houseNum +
          "-" +
          data.roomNum;
        arr.push(data);
        if (!flag) {
          isCheckPass = false;
        }
      }
      if (isCheckPass) {
        this.houseInfo.houseList = arr;
        this.$http.roomBksApi
          .saveUploadHouseInfo(this.houseInfo)
          .then(res => {
            this.loading = false;
            if (res.result == 0) {
              this.$emit("nextStep", 2, res.resultObject);
            }
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        this.loading = false;
      }
    },
    prevStep() {
      this.$emit("prevStep");
    }
  }
};
</script>

<style lang="less">
.add-new {
  width: 100%;
  margin: 10px auto 8px;
  display: block;
}
.operation {
  text-align: center;
  margin: 20px auto;
}
.step-form-style-desc {
  padding: 0 56px;
  color: rgba(0, 0, 0, 0.45);

  h3 {
    margin: 0 0 12px;
    color: rgba(0, 0, 0, 0.45);
    font-size: 16px;
    line-height: 32px;
  }

  h4 {
    margin: 0 0 4px;
    color: rgba(0, 0, 0, 0.45);
    font-size: 14px;
    line-height: 22px;
  }

  p {
    margin-top: 0;
    margin-bottom: 12px;
    line-height: 22px;
  }
}
</style>
